import { Outlet } from "react-router-dom";
import { useAuth } from "../utils/Auth/AuthProvider";

export const ProtectedRoute = () => {
    const { token } = useAuth();
  
    // Check if the user is authenticated
    if (!token) {
      // If not authenticated, redirection is handled by AuthProvider
      return null; // Or a loading spinner, or a component that doesn't navigate
    }
  
    // If authenticated, render the child routes
    return <Outlet />;
  };